
export class FormHandler {
    public static async sendFormData(data: any, id: number, lang: string) {
        const config = useRuntimeConfig()

        const response = await $fetch(`${config.public.API_BASE_URL}v1/form-data`, {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'x-api-key': config.public.API_KEY,
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: data
        })

        return response
    }
    
    public static validateField (field: any) {
        const mailFormatRegEx = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
        const htmlTagRegEx = /<(\w+)((?:\s+\w+(?:\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)>/

        if (field.required && field.value.trim() === '') {
            this.setStatus(field, 'error', 'Feld muss gefüllt sein')
        } else {
            this.setStatus(field, 'success')

            switch (field.type) {
                case 'email':
                    // check if value is a valid email-format    
                    if (field.value.match(mailFormatRegEx)) {
                        this.setStatus(field, 'success')
                    } else {
                        this.setStatus(field, 'error', 'Eingabe muss eine E-Mailadresse sein')
                    }
                    break
                case 'text':
                    // check if textfield is filled when required
                    if (field.required === 1 && field.value.length < 2) {
                        this.setStatus(field, 'error', 'Es müssen mindestens 2 Zeichen eingegeben werden')
                    }
                    // check if value contains htmltags 
                    else if (field.value.match(htmlTagRegEx)) {
                        this.setStatus(field, 'error', 'Ungültige Zeichenfolgen')
                    }
                    // check if value is longer than 50 signs 
                    else if (field.value.length > 50) {
                        this.setStatus(field, 'error', 'Eingabe ist zu lang: max. 50 Zeichen')
                    } else {
                        this.setStatus(field, 'success')
                    }
                    break
                case 'checkbox': 
                    // check if required checkbox is not checked
                    if (field.required && !field.checked) {
                        this.setStatus(field, 'error', 'Muss gecheckt sein')
                    } else {
                        this.setStatus(field, 'success')
                    }
            }
        }
    }

    public static setStatus (field: any, status: string, message: string = '') {
        const errorMessage = field.parentElement.querySelector('.error-message')

        if (status === 'success') {
            errorMessage.innerText = ''
            field.classList.remove('input-error')
        }

        if (status === 'error') {
            errorMessage.innerText = message
            field.classList.add('input-error')
            field.focus()
        }
    }

    public static checkHoneypot (field: any) {
        switch (field.id) {
            case 'input-chocolate-chips':
                if (field.value != '') {
                    field.classList.add('input-error')
                }
                break
            case 'input-gummy-bears':
                if (field.value != 'this-is-fine') {
                    field.classList.add('input-error')
                }
        }
    }

    public static validateOnSubmit (fields: any) {
        fields.pop()
        
        fields.forEach((field: any) => {
            if (field.id != 'input-chocolate-chips' && field.id != 'input-gummy-bears') {
                this.validateField(field)
            } else {
                this.checkHoneypot(field)
            }
        });
    }
}